import { Dropdown } from '@/components/Dropdown';
import { THEME_PRESETS, type ThemePreset, useTheme } from '@/contexts/ThemeContext';

/**
 * Przełącznik motywu kolorystycznego (preset). Wybór zapamiętany per przeglądarka
 * (localStorage); docelowo per user na koncie — osobny krok (backend).
 */
export function ThemePresetToggle() {
  const { preset, setPreset } = useTheme();
  return (
    <label className="flex items-center gap-1.5 text-xs text-text-muted">
      <span className="hidden sm:inline">Motyw</span>
      <Dropdown
        value={preset}
        onChange={(v) => setPreset(v as ThemePreset)}
        options={THEME_PRESETS.map((p) => ({ value: p.value, label: p.label }))}
        aria-label="Motyw kolorystyczny"
        className="w-auto px-2 py-1 text-xs"
      />
    </label>
  );
}
